export default __webpack_public_path__ + "static/media/bullet-youngjamove.cba7ced7.gif";